var styleDataHash = "7579be4d";
const injectCss = (() => {
  var css = `.u1Z-C{position:relative}.u1Z-C,.u1Z-C:before{left:0;top:0;width:100%}.u1Z-C:before{content:"";cursor:move;height:100%;position:absolute;z-index:5}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var overlay_hoc_default = {
  "overlay": "u1Z-C"
};
export {
  overlay_hoc_default as default,
  injectCss
};
//# sourceMappingURL=overlay-hoc-scss.js.map
